import React from 'react';
import { FormControl, Select, MenuItem, InputLabel, makeStyles, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  formControl: {
    minWidth: 300,
    marginBottom: theme.spacing(3)
  },
  select: {
    '& .MuiSelect-select': {
      display: 'flex',
      alignItems: 'center'
    }
  },
  loadingSpinner: {
    marginLeft: theme.spacing(1),
    color: theme.palette.primary.main
  }
}));

export default function ApplicantSelector({ applicants, currentApplicantId, onSelectApplicant, isLoading }) {
  const classes = useStyles();

  const handleChange = (event) => {
    const selectedApplicant = applicants.find(applicant => applicant.id === event.target.value);
    if (selectedApplicant) {
      onSelectApplicant(selectedApplicant);
    }
  };

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <InputLabel id="applicant-select-label">Select Applicant</InputLabel>
      <Select
        labelId="applicant-select-label"
        id="applicant-select"
        value={currentApplicantId || ''}
        onChange={handleChange}
        label="Select Applicant"
        className={classes.select}
        disabled={isLoading}
        endAdornment={isLoading && <CircularProgress size={20} className={classes.loadingSpinner} />}
      >
        {applicants.map((applicant) => (
          <MenuItem key={applicant.id} value={applicant.id}>
            {applicant.name} - {applicant.crop_type || 'Unknown Crop'} ({applicant.area_hectares ? `${applicant.area_hectares} hectares` : 'Unknown size'})
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
